/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DashboardFilterSchema } from './dashboard-filter-schema';
import { DashboardViewSchema } from './dashboard-view-schema';
import { DroppedBindingDto } from './dropped-binding-dto';
import { DashboardLocalizedCopyDto } from './dashboard-localized-copy-dto';
import { CompareTo } from './compare-to';


export interface UpsertFilterResponseDto { 
    _id: string;
    /**
     * Human-readable dashboard name in English; users see it when i18n has no entry for their language.
     */
    name: string;
    /**
     * Optional longer dashboard description or usage note, in English.
     */
    description?: string;
    /**
     * The dashboard\'s name and description in languages other than English, keyed by two-letter lowercase language code, at most 20 languages, for example {\"de\": {\"name\": \"Umsatzübersicht\", \"description\": \"Umsatz je Filiale\"}}. English goes in the plain name and description; an en key is rejected. A client shows the entry for the viewer\'s language, else the plain name and description. Null when there are no translations.
     */
    i18n?: { [key: string]: DashboardLocalizedCopyDto; } | null;
    programId: string;
    ownerUserId: string;
    createdBy: string;
    status: UpsertFilterResponseDto.StatusEnum;
    /**
     * Position of this dashboard among the Home tabs; null means it is not on Home. Home shows published dashboards only, so an archived dashboard leaves Home without this value changing.
     */
    homeOrder?: number | null;
    /**
     * Freeform dashboard layout state owned by the UI.
     */
    layout?: { [key: string]: any; };
    /**
     * Dashboard filters. Array order is display order. A new dashboard has none.
     */
    filters: Array<DashboardFilterSchema>;
    /**
     * Apply filter changes as soon as they are made; when false the viewer waits for an Apply button.
     */
    autoApplyFilters: boolean;
    /**
     * The dashboard\'s default Compare to; the viewer can switch it while viewing. What every count, amount and percentage tile compares its total with: previous_period (N whole months, quarters, years or weeks with the N before them, a month, quarter, year or week so far with the same days of the one before, any other range with as many days just before it) or same_period_last_year (the same dates a year earlier, 29 February as 28 February; whole months, quarters or years with the same units to their last day). null is Off. Trend and chart tiles are not affected.
     */
    compareTo: CompareTo | null;
    /**
     * Saved reading states for this dashboard. Applying one replaces the board\'s filter selections wholesale. Array order is display order.
     */
    views: Array<DashboardViewSchema>;
    /**
     * Tile bindings of this filter removed because the filter\'s new type cannot feed the bound KPI parameter. Empty unless the write changed the filter\'s type.
     */
    droppedBindings: Array<DroppedBindingDto>;
}
export namespace UpsertFilterResponseDto {
    export const StatusEnum = {
        Draft: 'draft',
        Published: 'published',
        Archived: 'archived'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


